import { homedir } from 'node:os';
import { join } from 'node:path';

/**
 * Base URL of the FIM gateway the CLI talks to.
 *
 * Defaults to the hosted production gateway so the installed, env-less binary
 * works out of the box (no repo `.env` to fall back on). `FUTUREX_API_URL`
 * (preferred) or `API_URL` override it; local dev sets `API_URL` in `.env`
 * (e.g. `http://localhost:4000`). The CLI appends `/api/v1/...` itself, so this
 * is the bare origin with no trailing slash and no `/api/v1` suffix.
 */
const DEFAULT_API_URL = 'https://api.futurim.org';

export function apiBaseUrl(): string {
  return process.env.FUTUREX_API_URL ?? process.env.API_URL ?? DEFAULT_API_URL;
}

/**
 * The FutureX home directory (`~/.futurex`) holding credentials, the permission
 * store, pipelines, and the index. `FUTUREX_HOME` overrides it (tests, CI).
 */
export function futurexHome(): string {
  return process.env.FUTUREX_HOME ?? join(homedir(), '.futurex');
}

/** Where credentials are stored (Phase 0/1: plain file under the home dir). */
export function credsPath(): string {
  return join(futurexHome(), 'credentials.json');
}

/**
 * The per-project permission store. Deliberately under the HOME dir (keyed by
 * project root) and never inside the repo — a cloned repository must not be able
 * to grant itself permissions.
 */
export function permissionsPath(): string {
  return join(futurexHome(), 'permissions.json');
}

/** Optional planning-config overrides (effort/value/budget knobs). */
export function planningConfigPath(): string {
  return join(futurexHome(), 'planning.json');
}
